import { MapElement } from '../../../shared/map/map-element.model';
import { Point } from 'geojson';

export const layersEnabledForFollow = new Set(['Junat', 'Kalusto']);
export const isFollowingAvailableForFeature = (feature: MapElement<Point>): boolean => layersEnabledForFollow.has(feature.layer.title);
